import styled from "styled-components";
import theme from "./../../styles/theme";

export const FooterSustainability = styled.div`
  padding: 35px 0px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const FooterRange = styled.div`
  width: 100%;
  background: ${theme.colors.gray};
  padding: 40px;
  margin-bottom: 20px;
  text-align: start;

  img {
    width: 130px !important;
    height: 49px;
  }
`;
export const FooterLogos = styled.div`
  display: flex;
  gap: 50px;
  padding: 20px 0px;

  div {
    width: auto !important;
  }

  @media (max-width: ${theme.breakpoints.medium}) {
    gap: 20px;
    padding: 10px 40px;
    justify-content: space-between;
    width: 100%;
  }
`;

export const FooterLogosBoxDesk = styled.div`
  display: flex;
  justify-content: center;
  gap: 50px;
  width: 100%;

  @media (max-width: ${theme.breakpoints.medium}) {
    display: none;
  }
`;

export const FooterLogosBoxMobile = styled.div`
  display: none;

  @media (max-width: ${theme.breakpoints.medium}) {
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 80px;
    padding: 20px 30px;

    .RowSchutz {
      gap: 28px;
    }
    .RowAnacapri {
      gap: 30px;
    }
  }
`;

export const FooterLogosMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;

  div {
    width: auto !important;
  }
`;
